require('./_global.js');
// import * as citation from './citation.js';
import { createApp } from "vue";
import objectHelpEmail from './app/vue/object-help-email.vue';
import objectLearningTips from './app/vue/object-help-in-person.vue';

$(document).ready(function() {

  const objectHelpApp = createApp(objectHelpEmail);
  const learningTipsApp = createApp(objectLearningTips);

  objectHelpApp.mount('#object-help');
  learningTipsApp.mount('#object-help-in-person');

});
